import { Button, Modal } from "react-bulma-components";
import { confirmable, createConfirmation } from "react-confirm";
import { useT } from "i18n/I18nProvider";

const Confirm = confirmable(({ show, proceed, cancel, confirmation }) => {
  const t = useT();
  return (
    <Modal show={show} closeOnBlur closeOnEsc onClose={cancel}>
      <Modal.Card>
        <Modal.Card.Header>
          <Modal.Card.Title>{confirmation}</Modal.Card.Title>
        </Modal.Card.Header>
        <Modal.Card.Footer>
          <Button color="primary" onClick={() => proceed()}>
            {t("common.yes")}
          </Button>
          <Button onClick={() => cancel()}>{t("common.no")}</Button>
        </Modal.Card.Footer>
      </Modal.Card>
    </Modal>
  );
});

const confirmation = createConfirmation(Confirm);

export const confirm = async (message: string) => {
  try {
    await confirmation({ confirmation: message });
    return true;
  } catch {
    return false;
  }
};
